import type { DriveFileSelection, DriveWriteCondition } from './types';

/**
 * The condition every document upload sends: replace exactly the revision the
 * app last downloaded or uploaded (its ETag), or — for a file the app has
 * never transferred — create it without replacing anything that is already
 * there. Either way a change made elsewhere in between is a 412 instead of a
 * silent overwrite.
 */
export function driveWriteCondition(selection: Pick<DriveFileSelection, 'etag'>): DriveWriteCondition {
  return selection.etag ? { etag: selection.etag } : { createOnly: true };
}

/** A Drive answer that means "somebody else changed this file" (409/412) — show the conflict, never retry blindly. */
export function isDriveConflict(error: unknown): boolean {
  const status = Number((error as { status?: unknown } | null | undefined)?.status);
  return status === 409 || status === 412;
}
